import React, { useState } from "react";
import { Card, Table, Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import { FaPlus, FaRedo, FaFilter, FaSort, FaSearch, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const initialBookIssues = [
  { name: "Physics Book", user: "John Doe", issueDate: "2023-12-01", submissionDate: "2023-12-15", status: "Active" },
  { name: "Maths Book", user: "Jane Smith", issueDate: "2023-11-20", submissionDate: "2023-12-05", status: "Inactive" },
  { name: "Chemistry Book", user: "Alice Johnson", issueDate: "2023-10-10", submissionDate: "2023-11-25", status: "Active" },
  { name: "Biology Book", user: "Bob Brown", issueDate: "2023-12-10", submissionDate: "2023-12-30", status: "Active" },
];

const LibraryBookIssueTable = () => {
  const [bookIssues, setBookIssues] = useState(initialBookIssues);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const handleSearch = (e) => setSearchQuery(e.target.value);

  const handleDelete = (index) => {
    const updatedBookIssues = [...bookIssues];
    updatedBookIssues.splice(index, 1);
    setBookIssues(updatedBookIssues);
  };

  const filteredBookIssues = bookIssues.filter((issue) =>
    issue.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedBookIssues = filteredBookIssues.slice(startIndex, startIndex + itemsPerPage);

  const pageCount = Math.ceil(filteredBookIssues.length / itemsPerPage);

  return (
    <Card className="border-0 shadow-sm">
      <Card.Header className="d-flex justify-content-between align-items-center bg-white border-0">
        <div>
          <h4 className="mb-1">Library Book Issues</h4>
          <Button variant="primary" className="d-flex align-items-center" onClick={() => navigate("/organisation/library/add-book-issue")}>
            <FaPlus className="me-2" /> Add Book Issue
          </Button>
        </div>
        <div className="d-flex align-items-center">
          <Button variant="light" className="me-2">
            <FaFilter />
          </Button>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
          <InputGroup style={{ width: "300px" }} className="me-2">
            <InputGroup.Text className="bg-white border-0">
              <FaSearch />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              className="rounded-pill"
            />
          </InputGroup>
        </div>
      </Card.Header>
      <Card.Body>
        <div  >
          <Table hover className="mb-0" style={{ overflow: "auto" }}>
            <thead>
              <tr>
                <th>Name <FaSort /></th>
                <th>User</th>
                <th>Issue Date</th>
                <th>Submission Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedBookIssues.length > 0 ? (
                paginatedBookIssues.map((issue, index) => (
                  <tr key={index}>
                    <td>{issue.name}</td>
                    <td>{issue.user}</td>
                    <td>{issue.issueDate}</td>
                    <td>{issue.submissionDate}</td>
                    <td>
                      <span
                        className={`badge ${
                          issue.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {issue.status}
                      </span>
                    </td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle variant="light" size="sm" className="border-0">
                          Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item>
                            <FaEye className="me-2 text-primary" /> View
                          </Dropdown.Item>
                          <Dropdown.Item>
                            <FaEdit className="me-2 text-warning" /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDelete(index)}>
                            <FaTrash className="me-2 text-danger" /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    No results found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, filteredBookIssues.length)} of{" "}
            {filteredBookIssues.length} entries
          </div>
          <div>
            {[...Array(pageCount).keys()].map((page) => (
              <Button
                key={page}
                variant="light"
                className={`me-1 ${currentPage === page + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(page + 1)}
              >
                {page + 1}
              </Button>
            ))}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default LibraryBookIssueTable;
